/**
 * BPAFindingsDataGrid
 *
 * Grid component for the BPA Findings page.
 * Delegates configuration and data-fetching to `useBPAFindingsGridConfig`,
 * keeping this component purely presentational.
 *
 * Error state: shown as an inline alert so the user can see the problem
 * without losing the filter/header chrome.
 */

import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import React, { Suspense, useState } from 'react';

import { useBPAFindingsGridConfig } from './BPAFindingsDataGrid.config';
import BPANotesModal from './BPANotesModal';
import { BPAFinding } from '../../types/bpaFindings.types';

const BPAFindingsDataGrid: React.FC = () => {
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const [notesData, setNotesData] = useState({
    id: 0,
    title: '',
    haveUnreadNotes: false,
  });

  const openNotesModal = (rowData: BPAFinding) => {
    setNotesData({
      id: rowData.id,
      title: rowData.description || rowData.control_description || 'Finding',
      haveUnreadNotes: rowData.total_notes > 0 && rowData.unread_notes > 0,
    });
    setIsNotesModalOpen(true);
  };

  const { config, data, loading } = useBPAFindingsGridConfig(openNotesModal);

  return (
    <>
      <Suspense fallback={<LoadingScreen />}>
        <DataGrid config={config} data={data} loading={loading} />
      </Suspense>
      {isNotesModalOpen && (
        <BPANotesModal
          toggle={() => setIsNotesModalOpen(false)}
          findingId={notesData.id}
          title={notesData.title}
          haveUnreadNotes={notesData.haveUnreadNotes}
        />
      )}
    </>
  );
};

export default BPAFindingsDataGrid;
